/* libs/oyan-ui/src/lib/components/cards/components/gateway-card/gateway-card.component.scss */
/*# sourceMappingURL=gateway-card.component.css.map */
